module.exports = __webpack_public_path__ + "static/media/28.4e13750d.png";